import axios from "@/hooks/axios/axios";
import type {
  ContactMessagesResponse,
  ContactMessagesParams,
  ContactMessage,
} from "../types/contact.types";

export const getContactMessages = async (
  params: ContactMessagesParams = {},
): Promise<ContactMessagesResponse> => {
  const { data } = await axios.get("/contact/messages", { params });
  return data;
};

export const updateContactReadStatus = async (
  messageId: string,
  isRead: boolean,
): Promise<ContactMessage> => {
  const { data } = await axios.patch(`/contact/messages/${messageId}/read`, {
    is_read: isRead,
  });
  return data;
};

export const markContactAsUnread = async (
  messageId: string,
): Promise<ContactMessage> => {
  const { data } = await axios.patch(`/contact/messages/${messageId}/unread`);
  return data;
};
